import React from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import { PaginationPropShape } from '../Infrastructure/propShapes'
import { translateResourceString } from '../../util/translationUtility';

class PageNumbers extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        
    }
    
    render() {
        
        const {
            pagination,
        } = this.props;
        
        const pageCount = Math.ceil(pagination.resultsTotal / pagination.currentItemsPerPage);

        return (
            <div className="page-numbers">
                
                <ReactPaginate 
                    pageCount={pageCount} // Number Required. The total number of pages.
                    pageRangeDisplayed={4} // Number Required. The range of pages displayed.
                    marginPagesDisplayed={0} // The number of pages to display for margins.
                    previousLabel={translateResourceString("/Search/PageNumbersPrev")}
                    nextLabel={translateResourceString("/Search/PageNumbersNext")}
                    forcePage={pagination.currentPageIndex}
                    onPageChange={(selectedItem) => this.props.onCurrentPageIndexChange(selectedItem.selected)}
                />
                
            </div>
        );
    }
}

PageNumbers.propTypes = {...PaginationPropShape};

export default PageNumbers;